import { Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './auth/AuthContext';
import LandingPage from './pages/LandingPage';
import LoginPage from './auth/LoginPage';
import DashboardPage from './dashboard/DashboardPage';
import NewProjectPage from './dashboard/NewProjectPage';
import ProjectDetailPage from './dashboard/ProjectDetailPage';
import DiplomaPage from './dashboard/DiplomaPage';
import RoleSessionPage from './chat/RoleSessionPage';
import TeacherDashboardPage from './teacher/TeacherDashboardPage';
import StudentDetailPage from './teacher/StudentDetailPage';
import NotFoundPage from './pages/NotFoundPage';

function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="loading">Yükleniyor…</div>;
  if (!user) return <Navigate to="/login" replace />;
  return <>{children}</>;
}

function AppRoutes() {
  const { user, loading } = useAuth();
  if (loading) return <div className="loading">Yükleniyor…</div>;

  return (
    <Routes>
      <Route path="/" element={<LandingPage />} />
      <Route
        path="/login"
        element={user ? <Navigate to="/app" replace /> : <LoginPage />}
      />
      <Route
        path="/app"
        element={
          <ProtectedRoute>
            <DashboardPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/projects/new"
        element={
          <ProtectedRoute>
            <NewProjectPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/projects/:projectId"
        element={
          <ProtectedRoute>
            <ProjectDetailPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/projects/:projectId/diploma"
        element={
          <ProtectedRoute>
            <DiplomaPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/projects/:projectId/roles/:roleId"
        element={
          <ProtectedRoute>
            <RoleSessionPage />
          </ProtectedRoute>
        }
      />

      <Route
        path="/teacher"
        element={
          <ProtectedRoute>
            <TeacherDashboardPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/teacher/students/:studentId"
        element={
          <ProtectedRoute>
            <StudentDetailPage />
          </ProtectedRoute>
        }
      />

      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <AppRoutes />
    </AuthProvider>
  );
}
